import React from 'react'
import {
    Button,
    DropdownSearch,
    type DropdownSearchProps,
    Input,
    type SelectOption,
} from '@dostavkee/web-ui'

import { useRecruiterOptionsFetch } from '@/entities/recruiter'
import { useDeviceDetect } from '@/shared/model'
import { CellRadioGroup } from '@/shared/ui/cell-radio'
import { Drawer } from '@/shared/ui/drawer'

interface RecruiterDropdownSearchProps
    extends Omit<DropdownSearchProps, 'options' | 'isLoading' | 'label' | 'value'> {
    value?: SelectOption['id']
}

const snapPoints = [1]

export const RecruiterDropdownSearch: React.FC<RecruiterDropdownSearchProps> = ({ ...props }) => {
    const { recruiterOptions, isLoading } = useRecruiterOptionsFetch()
    const { isMobile, isTablet } = useDeviceDetect()
    const [isRecruiterSearchOpen, setIsRecruiterSearchOpen] = React.useState(false)
    const [snap, setSnap] = React.useState<number | string | null>(snapPoints[0])

    if (isMobile || isTablet) {
        return (
            <>
                <Drawer.NestedRoot
                    activeSnapPoint={snap}
                    open={isRecruiterSearchOpen}
                    setActiveSnapPoint={setSnap}
                    snapPoints={snapPoints}
                    onOpenChange={setIsRecruiterSearchOpen}
                >
                    <Drawer.Trigger asChild>
                        <Input
                            label='Вербовщик'
                            size='large'
                            type='button'
                            value={
                                recruiterOptions?.find((option) => option.id === props.value)?.name
                            }
                        />
                    </Drawer.Trigger>
                    <Drawer.Content ariaDescription='Выберите вербовщика из списка'>
                        <Drawer.Header title='Выберите вербовщика' />
                        <Drawer.Body>
                            <CellRadioGroup>
                                {recruiterOptions?.map((option) => (
                                    <CellRadioGroup.Button
                                        key={option.id}
                                        checked={props.value === option.id}
                                        label={option.name}
                                        name={props.name ?? ''}
                                        value={option.id.toString()}
                                        onChange={() => {
                                            props.onSelect(option)
                                        }}
                                    />
                                ))}
                            </CellRadioGroup>

                            <footer style={{ paddingTop: '16px' }}>
                                <Drawer.Close asChild>
                                    <Button fullWidth size='large' variant='primary'>
                                        Выбрать
                                    </Button>
                                </Drawer.Close>
                            </footer>
                        </Drawer.Body>
                    </Drawer.Content>
                </Drawer.NestedRoot>
            </>
        )
    }

    return (
        <DropdownSearch
            {...props}
            isLoading={isLoading}
            label='Вербовщик'
            options={recruiterOptions}
            value={recruiterOptions?.find((option) => option.id === String(props.value))}
        />
    )
}
